import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchOwnerLocationOfInstallation } from '../api/installation-details.api'
import { ApiAccountType, usePortalQuery } from 'src/Libs/api'
import { OwnerLocationOfInstallation } from '../models'

type DataReturnType = [OwnerLocationOfInstallation | null | undefined, boolean]

export const useOwnerLocationOfInstallation = (ownerType: ApiAccountType, ownerId: number | undefined): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const fetchOwnerLocationOfInstallationQueryFn = async (): Promise<OwnerLocationOfInstallation | null> => {
    if (!ownerId) {
      throw new Error('Owner ID is missing')
    }

    const { error, hasErrors, value } = await fetchOwnerLocationOfInstallation(ownerId, ownerType, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred while fetching owner location data')
    }

    return value
  }

  const { data: ownerLocation, isLoading: ownerLocationLoading } = usePortalQuery({
    queryKey: ownerType === 'company' ? ['users', 'companies', ownerId, 'location'] : ['users', ownerId, 'location'],
    queryFn: fetchOwnerLocationOfInstallationQueryFn,
    enabled: !!ownerId,
  })

  return [ownerLocation, ownerLocationLoading]
}
